import OITOpacityNavigator from "./oitOpacityNavigator";

class VolumeOpacity {
    constructor(){
        this.invisibleOpacity = 0.0;
        this.transparentOpacity = 0.4;
        this.disableOpacity = 2.0;
        this.animationList = {};
        this.volumes = {};
        this.oitOpacityNavigator = new OITOpacityNavigator();
    }

    calculateOpacity(isVisible, isTransparent, branchId) {
        if (!isVisible) return this.invisibleOpacity;
        if (!branchId) return this.disableOpacity;
        
        const model = modelManager.getModelById(getModelIdFromBranchId(branchId));
        const excludeBranchIds = model?.additionalMeshData?.opacities || {};
        const opacity = excludeBranchIds[branchId.split('_')[1]];
        if (opacity && opacity !== -1 && wv.effectController.transparencyEnabled) {
            return opacity;
        } else if (isTransparent) return this.transparentOpacity;

        return this.disableOpacity;
    }

    setVisibilityHelper(branchId, isVisible, animationDuration = 500) {
        if (!this.volumes.hasOwnProperty(branchId)) {
            const volume = modelManager.getVolume(branchId);
            this.volumes[branchId] = {
                'isVisible': isVisible,
                'isTransparent': volume.isTransparent
            };
        }
        const curOpacity = this.calculateOpacity(isVisible, this.volumes[branchId].isTransparent, branchId);
        const prevOpacity = this.calculateOpacity(this.volumes[branchId].isVisible, this.volumes[branchId].isTransparent, branchId);
        this.volumes[branchId].isVisible = isVisible;
        this.opacityChangeAnimation(branchId, curOpacity, prevOpacity, animationDuration)?.start();
    }

    restoreVolumeTransparency(branchId, modelId, applyTransparency) {
        const coreBranchId = branchId.split("_")[1];
        const model = modelManager.getModelById(modelId);
        let opacity = 2.0;

        function isTransparent(coreBranchId) {
            if (!wv.effectController.transparencyEnabled) {
                return false;
            }

            opacity = model?.additionalMeshData?.opacities?.[coreBranchId] ? model?.additionalMeshData?.opacities?.[coreBranchId][0] : undefined;
            return opacity !== undefined && opacity !== -1;
        }

        if (isTransparent(coreBranchId)) {
            if (applyTransparency) {
                this.setTransparencyHelper(branchId, applyTransparency, 0, opacity);
            } else {
                opacity = 2.0;
                this.setTransparencyHelper(branchId, applyTransparency, 0, opacity);
            }
        }
    }

    setTransparencyHelper(branchId, isTransparent, animationDuration = 500, opacity) {
        const curOpacity = opacity || this.calculateOpacity(this.volumes[branchId].isVisible, isTransparent, branchId);
        const prevOpacity = this.calculateOpacity(this.volumes[branchId].isVisible, this.volumes[branchId].isTransparent, branchId);
        this.volumes[branchId].isTransparent = isTransparent;

        if (isTransparent) {
            const opacityAnimation = this.opacityChangeAnimation(branchId, curOpacity, prevOpacity, animationDuration); // early prepare of animation is required for correct cancellation of old one
            this.oitOpacityNavigator.debounceRequests(branchId, isTransparent, () => opacityAnimation?.start());
        }
        else {
            const opacityAnimation = this.opacityChangeAnimation(branchId, curOpacity, prevOpacity, animationDuration, () => {
                this.oitOpacityNavigator.debounceRequests(branchId, isTransparent, () => {});
            });
            opacityAnimation?.start();
        }
    }

    setOpacity(branchId, opacity) {
        const model = modelManager.getModelById(getModelIdFromBranchId(branchId));
        if (model) {
            model.baseMaterial?.setOpacity(branchId, opacity);
        }
    }

    mapOpacity(opacity) {
        return (Math.abs(opacity - this.disableOpacity) < 1e-3) ? 1.0 : opacity;
    }

    opacityChangeAnimation(branchId, newValue, oldValue, animationDuration, callbackFn) {

        if (this.animationList[branchId]) {
            this.animationList[branchId].stop();
        }
        const self = this;
        if (!animationDuration || newValue === oldValue) {
            onComplete();
            return null;
        } else {
            const current = {value: this.mapOpacity(oldValue)};
            const target = {value: this.mapOpacity(newValue)};
            this.animationList[branchId] = new TWEEN.Tween(current)
                .to(target, animationDuration)
                .onUpdate(() => this.setOpacity(branchId, current.value))
                .onComplete(onComplete)
                .onStop(onStop);

            return this.animationList[branchId];
        }

        function onComplete() {
            onStop();
            if (callbackFn) {
                callbackFn();
            }
        }
        function onStop() {
            self.setOpacity(branchId, newValue);
            self.animationList[branchId] = null;
        }
    }
}

export default VolumeOpacity;
